import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/useI18n';

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="site-footer">
      <div>
        <strong>DDProof Camera</strong>
        <p>{t('footer.text')}</p>
      </div>
      <div className="footer-links">
        <Link to="/privacy">{t('nav.privacy')}</Link>
        <Link to="/terms">{t('nav.terms')}</Link>
        <Link to="/delete-account">{t('nav.deleteAccount')}</Link>
        <Link to="/download">{t('nav.download')}</Link>
        <a href="https://verify.ddproof.com/">{t('footer.verify')}</a>
      </div>
    </footer>
  );
}
